/* eslint-disable */
import { createStructuredSelector } from 'reselect';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { storeActive } from 'ggApp/modules/store/selectors';
import { mainTransition, transitionTo } from 'ggApp/modules/router/actions';
import { location } from 'ggApp/modules/router/selectors';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import { orderActive as orderActiveSelector } from 'ggApp/modules/order/selectors';

import SingleProduct from './SingleProduct';

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            activeStore: storeActive,
            orderActive: orderActiveSelector,
            location,
        }),
        (dispatch) => ({
            mainTransition: bindActionCreators(mainTransition, dispatch),
            transitionTo: bindActionCreators(transitionTo, dispatch),
        }),
    ),
    withProps(({
        userDevice,
    }) => ({
        isDesktopUser: (userDevice !== 'mobile') && (userDevice !== 'tablet'),
    })),
);

export default enhance(SingleProduct);
